import { createContext, useContext, useState, useEffect, useCallback } from "react";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [institution, setInstitution] = useState(null);
  const [examinerMode, setExaminerMode] = useState(localStorage.getItem("atom.examiner") === "1");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const u = localStorage.getItem("atom.user");
    const inst = localStorage.getItem("atom.institution");
    if (u) setUser(JSON.parse(u));
    if (inst) setInstitution(JSON.parse(inst));
    setLoaded(true);
  }, []);

  const login = useCallback((u) => {
    localStorage.setItem("atom.user", JSON.stringify(u));
    setUser(u);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("atom.user");
    setUser(null);
  }, []);

  const switchInstitution = useCallback((inst) => {
    localStorage.setItem("atom.institution", JSON.stringify(inst));
    setInstitution(inst);
  }, []);

  const toggleExaminer = useCallback(() => {
    setExaminerMode(prev => {
      const next = !prev;
      if (next) localStorage.setItem("atom.examiner", "1");
      else localStorage.removeItem("atom.examiner");
      return next;
    });
  }, []);

  return (
    <AuthCtx.Provider value={{ user, institution, examinerMode, login, logout, switchInstitution, toggleExaminer, loaded }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
